export default Object.freeze({
  TITLE: '임시 비밀번호 발급',
  TARGET_MEMBER: '대상회원',
  NOTICE: '임시 비밀번호 발급 안내',
  ISSUANCE: '발급',
  ALERT_NO_ACTIVE_MEMBER:
    '회원상태가 가입완료 상태인 회원에게만 임시 비밀번호 발급이 가능합니다.',
  ALERT_ISSUANCE_COMPLETE: '발급이 완료되었습니다.',
  ALERT_NO_EMAIL: '이메일 정보가 없는 회원입니다.',
  ALERT_NO_EMAIL_AGREED:
    '메일발송이 불가합니다.\n자동 메일 설정을 확인해주세요.',
  ALERT_NO_SMS: '휴대폰 번호가 없는 회원입니다.',
  ALERT_NO_SMS_AGREED: '메일발송이 불가합니다.\n자동 SMS 설정을 확인해주세요.',
})
